import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';

const navItems = [
  { name: 'Home', path: '/', icon: 'Home' },
  { name: 'Image to SVG', path: '/vectorizer', icon: 'Image' },
  { name: 'Favicons', path: '/favicon', icon: 'Grid' },
  { name: 'QR Codes', path: '/qr', icon: 'Maximize' },
];

const Header = () => {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const navLink = (item, mobile = false) => (
    <Link
      key={item.path}
      to={item.path}
      onClick={() => setOpen(false)}
      className={`${mobile ? 'w-full justify-start px-4 py-3' : 'px-3 py-2'} rounded-lg text-sm font-medium transition-colors flex items-center gap-2 ${
        location.pathname === item.path
          ? 'bg-indigo-50 text-indigo-700'
          : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'
      }`}
    >
      <SafeIcon name={item.icon} className="w-4 h-4" />
      {item.name}
    </Link>
  );

  return (
    <header className="bg-white/90 backdrop-blur-md border-b border-slate-200/80 sticky top-0 z-50 shadow-sm">
      <div className="container mx-auto px-4 h-14 md:h-16 flex items-center justify-between max-w-6xl">
        <Link to="/" onClick={() => setOpen(false)} className="flex items-center gap-2 min-w-0" aria-label="VectorCraft Studio home">
          <div className="bg-gradient-to-br from-indigo-500 to-purple-600 text-white p-1.5 rounded-lg flex-shrink-0">
            <SafeIcon name="Feather" className="w-5 h-5" />
          </div>
          <span className="font-bold text-base sm:text-lg md:text-xl tracking-tight text-slate-800 truncate">VectorCraft Studio</span>
        </Link>

        <nav className="hidden md:flex items-center gap-1" aria-label="Primary navigation">
          {navItems.map((item) => navLink(item))}
        </nav>

        <button
          type="button"
          className="md:hidden p-2 rounded-lg text-slate-600 hover:bg-slate-100 focus:outline-none focus-visible:ring-4 focus-visible:ring-indigo-300/50"
          aria-label={open ? 'Close navigation menu' : 'Open navigation menu'}
          aria-expanded={open}
          onClick={() => setOpen((value) => !value)}
        >
          <SafeIcon name={open ? 'X' : 'Menu'} className="w-5 h-5" />
        </button>
      </div>

      {open && (
        <nav className="md:hidden border-t border-slate-200 bg-white px-3 py-3 space-y-1" aria-label="Mobile navigation">
          {navItems.map((item) => navLink(item, true))}
        </nav>
      )}
    </header>
  );
};

export default Header;